import {
  Button,
  Form,
  FormItem,
  Header,
  InfoBlock,
  Input,
  ScrollView,
  Select,
} from '$uikit';
import React, { FC } from 'react';
import { AttachPhoto } from '$store/models';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '$store/rootReducer';
import { attachPhotosSelector } from '$store/attach';
import { offersActions, offersSelector } from '$store/offers';
import { formatInputAmount } from '$utils/number';
import { BundleAttach } from '$core/CreateBundle/BundleAttach/BundleAttach';
import { toastActions } from '$store/toast';
import { Api } from '$api';
import { useTranslator } from '$hooks';

export const NewOffer: FC = () => {
  const dispatch = useDispatch();
  const { create } = useSelector(offersSelector);
  const content: AttachPhoto[] = useSelector((state: RootState) =>
    attachPhotosSelector(state, 'offer'),
  );
  const t = useTranslator();

  const handleDescription = (e) => {
    dispatch(
      offersActions.createFormUpdate({
        description: e.target.value,
      }),
    );
  };

  const handleType = (e) => {
    dispatch(
      offersActions.createFormUpdate({
        type: e.target.value,
      }),
    );
  };

  const handlePercent = (e) => {
    dispatch(
      offersActions.createFormUpdate({
        percent: e.target.value,
      }),
    );
  };

  const handlePeriod = (e) => {
    dispatch(
      offersActions.createFormUpdate({
        periodDays: +e.target.value,
      }),
    );
  };

  const handleCreate = () => {
    dispatch(offersActions.createOffer());
  };

  return (
    <>
      <Header showCloseButton>{t('offer_create_title')}</Header>
      <ScrollView>
        <a
          href="https://telegra.ph/Offery-na-TonPlace-12-24"
          target="_blank"
          rel="noreferrer"
          style={{ padding: '0 16px', display: 'block' }}
        >
          <InfoBlock type="info" title={t('offer_create_wiki')} arrow />
        </a>
        <Form>
          <FormItem
            title={t('offer_create_description_title')}
            description={t('offer_create_description_caption')}
          >
            <Input
              placeholder={t('offer_create_description_placeholder')}
              value={create.description}
              onChange={handleDescription}
              multiline
            />
          </FormItem>
          <FormItem
            title={t('offer_create_percent_title')}
            description={t('offer_create_percent_caption')}
          >
            <Input
              placeholder={t('offer_create_percent_placeholder')}
              value={formatInputAmount(create.percent)}
              onChange={handlePercent}
            />
          </FormItem>
          <FormItem
            title={t('offer_create_type_title')}
            description={t('offer_create_type_caption')}
          >
            <Select value={create.type} onChange={handleType}>
              <option value="1">{t('offer_create_type_subscriptions')}</option>
              <option value="2">{t('offer_create_type_all')}</option>
            </Select>
          </FormItem>
          <FormItem
            title={t('offer_create_period_title')}
            description={t('offer_create_period_caption')}
          >
            <Select value={create.periodDays} onChange={handlePeriod}>
              <option value="7">{t('offer_create_period_7')}</option>
              <option value="30">{t('offer_create_period_30')}</option>
              <option value="90">{t('offer_create_period_90')}</option>
              <option value="180">{t('offer_create_period_180')}</option>
              <option value="365">{t('offer_create_period_365')}</option>
            </Select>
          </FormItem>
          <FormItem
            title={t('offer_create_content_title')}
            titleAfter={`${content.length}/30`}
            descriptionBeforeContent
            description={t('offer_create_content_caption')}
          >
            <BundleAttach pickerId="offer" decryptKey="" limit={30} />
          </FormItem>
          <FormItem>
            <Button onClick={handleCreate}>{t('offer_create_publish')}</Button>
          </FormItem>
        </Form>
      </ScrollView>
    </>
  );
};
